// @flow

import React, { type Node } from 'react';
import { AddPaymentMethodController } from './add-payment-method';

export function SavedFundingMethodController(props: SavedFundingMethodControllerProps): Node {
  const { action, tenantCode, lookAndFeelCode } = props;
  const subaction = extractSubaction(action);

  if (subaction === 'add-payment-method') {
    return (
      <AddPaymentMethodController
        tenantCode={tenantCode}
        lookAndFeelCode={lookAndFeelCode}
      />
    );
  }

  throw new Error(`Unknown Saved Funding Method service action: "${subaction}"`);
}

type SavedFundingMethodControllerProps = {
  action: string,
  tenantCode: ?string,
  lookAndFeelCode: ?string,
};

function extractSubaction(action: string): string {
  return action.split('/')[1];
}
